import React from 'react';
import { FaSquareMinus, FaSquarePlus } from 'react-icons/fa6';
import * as Styled from './styles';
import * as RiIcons from 'react-icons/ri';
import { useTranslation } from 'react-i18next';
import ReactTooltip from 'react-tooltip';
import { RiInformationLine } from 'react-icons/ri';

interface ILayerSelect {
  id: string;
  name: string;
  children: React.ReactNode;
  qtdOpened?: number;
  opened: boolean;
  is_new?: boolean;
  has_graph?: boolean;
  onChange: () => void;
  clear?: () => void;
  handleOpenGraph?: () => void;
  disabled?: boolean;
  camadas_filtradas?: string[];
}

export function LayerSelect({
  id,
  children,
  name,
  qtdOpened,
  opened,
  is_new,
  has_graph,
  onChange,
  handleOpenGraph,
  clear,
  disabled,
  camadas_filtradas,
}: ILayerSelect) {
  const { t: translation } = useTranslation();

  function handleClear(e: React.MouseEvent<HTMLElement>) {
    e.stopPropagation();
    if (clear) clear();
  }

  return (
    <Styled.Wrapper id={id} opened={opened} disabled={!!disabled}>
      <button className="selectLayer" onClick={onChange} disabled={disabled}>
        <div className="icon" data-tip data-for={disabled && `functionalDev_${id}`}>
          {!opened ? (
            <FaSquarePlus size={22} color={disabled ? '#69a7e0' : '#017ac6'} />
          ) : (
            <FaSquareMinus size={22} color={'#017ac6'} />
          )}
        </div>
        <p id={id} data-tip data-for={disabled && `functionalDev_${id}`}>
          <>
            {name}
            {camadas_filtradas && camadas_filtradas?.length > 0 && (
              <span
                style={{ marginLeft: 8, cursor: 'pointer' }}
                title={`Camadas pesquisadas: ${camadas_filtradas.join(', ')}`}
              >
                <RiInformationLine size={22} />
              </span>
            )}
          </>
        </p>
        {has_graph && (
          <Styled.Button className='graph-button' label={translation('mapPage.sideBar.layers.graphic')} onClick={handleOpenGraph}>
            <RiIcons.RiBarChart2Fill size={20} color="#000" />
          </Styled.Button>
        )}
        {!!qtdOpened && qtdOpened > 0 &&
          <Styled.Button label={'Limpar'} onClick={(e) => handleClear(e)}>
            <RiIcons.RiIndeterminateCircleLine size={20} color="#000" />
          </Styled.Button>
        }
        {!!qtdOpened && qtdOpened > 0 && clear && <span id="label_qtd_opened">{qtdOpened}</span>}
        {is_new && <span id="label_new">novo</span>}
      </button>
      {opened && <Styled.ContentLayer>{children}</Styled.ContentLayer>}
      <ReactTooltip id={`functionalDev_${id}`} place="right" type="warning" effect="solid" delayShow={500} delayHide={500}>
        <p>{translation('mapPage.sideBar.navigationRightBar.functionalDev')}</p>
      </ReactTooltip>
    </Styled.Wrapper>
  );
}
